/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file LicensePacksModal.tsx
 * @desc Created on Sat May 17 2025 02:00:21
 * @copyright All rights reserved @ Inarix
 */

import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  focusedLicense,
  selectAvailPacks,
  selectModalLicense,
} from "../../redux/slices/licenses/licenseList";
import { useTranslation } from "react-i18next";
import { renderLicenseCredits } from "./LicenceCredits";
import { bindPack } from "../../redux/actions/licenses/licenseListAsyncActions";

export const LicensePacksModal: FC = () => {
  const packs = useSelector(selectAvailPacks);
  const license = useSelector(selectModalLicense);
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const [checked, setChecked] = useState("");
  const checkHandler = (ev: any) => {
    setChecked(ev.target.value);
  };

  // type-safe if, won't ever happen
  if (!license) {
    return <></>;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 600,
        maxWidth: "calc(100% - 20px)",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
      }}
    >
      <div className="modal-detail-user-container">
        <div>
          <div className="username-title-modal">{t("licenses.addCreds")}</div>
        </div>

        <div className="access-and-permissions">
          <div className="access-title">{t("licenses.License")}</div>
          <div className="access-perm-info">
            <div className="access-values-users">
              <div className="option-left mt-2">
                <span className="title-view-span">
                  {t("Users_tables.columns_table_one.balance")}
                </span>
              </div>
              <div className="option-right">
                {renderLicenseCredits([license])}
              </div>
            </div>
            <div className="access-values-users">
              <div className="option-left">
                <span className="title-view-span">
                  {t("licenses.expiration")}
                </span>
              </div>
              <div className="option-right">
                {new Date(license.expiryDate).toLocaleDateString()}
              </div>
            </div>
            <div className="access-value-users">&nbsp;</div>
          </div>
          <div className="divider-user-details" />

          <FormControl
            sx={{ width: "100%", backgroundColor: "background.paper" }}
          >
            <RadioGroup onChange={checkHandler}>
              {packs.map((p) => (
                <FormControlLabel
                  label={`+ ${p.initialCredits} ${t("licenses.credits")}`}
                  control={<Radio value={p.id} />}
                  key={p.id}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </div>

        <div className="buttons-user-view">
          <div className="container-buttons-users-actions">
            <Button
              variant="outlined"
              onClick={() => dispatch(focusedLicense(""))}
              sx={{ textTransform: "none" }}
            >
              {t("Common_options.Cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                dispatch(
                  bindPack({ licenseId: license.id, packId: checked }) as any,
                );
                dispatch(focusedLicense(""));
              }}
              sx={{ textTransform: "none" }}
              disabled={!checked}
            >
              {t("Common_options.Add")}
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
};
